module.exports = __webpack_public_path__ + "assets/img/Employment-Innovations-Pillar-Page-Resource-w540.0f90c8b2.jpg";